/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FulfilledTestGroupDto } from './FulfilledTestGroupDto';
export type FulfilledTestAreaDto = {
    readonly id?: string;
    readonly name?: string;
    readonly testAreaType?: FulfilledTestAreaDto.testAreaType;
    readonly testGroups?: Array<FulfilledTestGroupDto>;
    readonly order?: number;
    fulfilled?: boolean;
};
export namespace FulfilledTestAreaDto {
    export enum testAreaType {
        SPECIFICATION = 'SPECIFICATION',
        GENERIC = 'GENERIC',
    }
}

